import { useTranslation } from 'react-i18next'
import Card from '@/components/ui/Card'
import { cn } from '@/utils/cn'

interface PrayerTime {
  name: string // i18n key: fajr, dhuhr, asr, etc.
  adhan: string
  iqama: string
}

interface PrayerScheduleTableProps {
  prayers: PrayerTime[]
  nextPrayerName?: string
}

export default function PrayerScheduleTable({ prayers, nextPrayerName }: PrayerScheduleTableProps) {
  const { t } = useTranslation()

  return (
    <Card>
      <h3 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-6">{t('prayer.prayerTimesTitle')}</h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-gray-200 dark:border-gray-700">
              <th className="text-right py-3 px-4 font-semibold text-gray-900 dark:text-gray-100">{t('prayer.prayerColumn')}</th>
              <th className="text-right py-3 px-4 font-semibold text-gray-900 dark:text-gray-100">{t('prayer.adhan')}</th>
              <th className="text-right py-3 px-4 font-semibold text-gray-900 dark:text-gray-100">{t('prayer.iqama')}</th>
            </tr>
          </thead>
          <tbody>
            {prayers.map((prayer, index) => {
              const isNext = nextPrayerName === prayer.name
              return (
                <tr
                  key={index}
                  className={cn(
                    'border-b border-gray-100 dark:border-gray-700 transition-colors',
                    isNext && 'bg-primary-50 dark:bg-primary-900/30',
                    'hover:bg-gray-50 dark:hover:bg-gray-700'
                  )}
                >
                  <td className="py-3 px-4">
                    <div className="flex items-center gap-2">
                      {isNext && (
                        <span className="w-2 h-2 bg-primary-600 dark:bg-primary-400 rounded-full animate-pulse" />
                      )}
                      <span className={cn('font-medium text-gray-900 dark:text-gray-100', isNext && 'text-primary-600 dark:text-primary-400 font-bold')}>
                        {t(`prayer.prayerNames.${prayer.name}`)}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-gray-700 dark:text-gray-300 font-mono">{prayer.adhan}</td>
                  <td className="py-3 px-4 text-gray-700 dark:text-gray-300 font-mono">{prayer.iqama}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </Card>
  )
}

